import ProfileNotifications from 'components/Profile/components/ProfileNotifications/ProfileNotifications';
import { FC } from 'react';

const ProfileNotificationPage: FC = () => {
	return <ProfileNotifications />;
};

export default ProfileNotificationPage;
